import { render, staticRenderFns } from "./eod-delete-dialog.vue?vue&type=template&id=475b2d2c&scoped=true"
import script from "./eod-delete-dialog.vue?vue&type=script&lang=js"
export * from "./eod-delete-dialog.vue?vue&type=script&lang=js"
import style0 from "./eod-delete-dialog.vue?vue&type=style&index=0&id=475b2d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b2d2c",
  null
  
)

export default component.exports